var map = {
	"./background_main.jpg": 1,
	"./ceat_large.jpg": 18,
	"./ceat_small.jpg": 19,
	"./gs_large.jpg": 20,
	"./gs_small.jpg": 21,
	"./ic_github.png": 3,
	"./ic_gmail.png": 4,
	"./ic_instagram.png": 5,
	"./ic_linkedin.png": 6,
	"./mgm_large.jpg": 22,
	"./mgm_small.jpg": 23,
	"./ricardo-gomez-angel-2oIgnII4f-0-unsplash -desk-1920.jpg": 24,
	"./ricardo-gomez-angel-2oIgnII4f-0-unsplash -large-2400.jpg": 25,
	"./ricardo-gomez-angel-2oIgnII4f-0-unsplash -small-640.jpg": 26,
	"./thc_large.jpg": 27,
	"./thc_small.jpg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;